import axios from "axios";

const getPost = async (toGet, slug) => {
	let dataAccess = "post";

	if (toGet === "casos-exito") {
		dataAccess = "caso";
	} else if (toGet === "carrera") {
		dataAccess = "career";
	}

	try {
		const response = await axios.get(
			`${process.env.REACT_APP_API_URL}/${toGet}/${slug}`
		);
		const post = response.data[dataAccess];
		if (response.status !== 200 || !post) {
			throw new Error("Error al obtener el post");
		}
		return post;
	} catch (e) {
		throw new Error("Error al obtener el post");
	}
};

export default getPost;
